import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import Login from "../pages/auth/login";
import AuthLayout from "../layout/auth";
import ForgotPassword from "../pages/auth/forgotPassword";
import EmailSent from "../pages/auth/emailSent";
import ResetPassword from "../pages/auth/resetPassword";
import TermsAndPolicy from "../pages/auth/termsAndPolicy";
import PrivacyPolicy from "../pages/auth/privacyPolicy";
import MainLayout from "../layout";
import AdminDashboard from "../pages/super-admin/adminDashboard";
import Referrals from "../pages/super-admin/referrals";
import { COURT_USER, SUPER_ADMIN } from "../constants";
import CourtDashboard from "../pages/court-user/courtDashboard";
import VerifyOtp from "../pages/auth/verifyOtp";
import Questions from "../pages/super-admin/question";
import QuestionDetails from "../pages/super-admin/question/show";
import Interest from "../pages/super-admin/interest";
import InterestDetails from "../pages/super-admin/interest/show";
import Ethnicities from "../pages/super-admin/ethnicities";
import EthnicityDetails from "../pages/super-admin/ethnicities/show";
import OriginCountries from "../pages/super-admin/origin-countries";
import OriginCountryDetails from "../pages/super-admin/origin-countries/show";
import BroadCast from "../pages/super-admin/broadcast";
import BroadCastDetails from "../pages/super-admin/broadcast/show";
import ContactUs from "../pages/super-admin/contact-us";
// import ContactUsDetails from "../pages/super-admin/contact-us/feedback";
import ListstyleQuestions from "../pages/super-admin/liststyle-questions";
import ListstyleQuestionDetails from "../pages/super-admin/liststyle-questions/show";
// import CourtUserBookings from "../pages/court-user/booking";
// import CourtUserPayments from "../pages/court-user/payment";
import Users from "../pages/super-admin/user";
import UserDetails from "../pages/super-admin/user/show";
import UserForm from "../pages/super-admin/user/form";
import ReferredUsers from "../pages/super-admin/user/referred-users";
import Profile from "../pages/super-admin/profile";
import UpdateProfile from "../pages/super-admin/updateprofile";
import Payments from "../pages/super-admin/payment";
import Subscriptions from "../pages/super-admin/subscription";
import SubscriptionDetails from "../pages/super-admin/subscription/show";
import SubscriptionAnalytics from "../pages/super-admin/subscription/analytics";
import Courts from "../pages/super-admin/court";
import Events from "../pages/super-admin/events";
import EventDetails from "../pages/super-admin/events/show";
import Pages from "../pages/super-admin/pages";
import Settings from "../pages/super-admin/setting";
import Reports from "../pages/super-admin/reports";
import GlobalTestAds from "../pages/super-admin/global-test-ads";

// import Waitlist from "../pages/super-admin/events/waitlist";
import UserVerification from "../pages/super-admin/user_verification";
// import CourtUserProfile from "../pages/court-user/profile";
import NotFound from "../pages/not-found";
// import Memberships from "../pages/super-admin/membership-plan";

const AuthRedirect = ({ destination }) => {
    return <Route render={(props) => (<Redirect to={{ pathname: destination, state: { from: props.location } }} />)} />
}

const wrapper = (Layout, Component) => {

    let accessToken = localStorage.getItem('token');

    const redirect = <AuthRedirect destination={'/login'} />

    if (accessToken == null) return redirect;

    return (
        <Layout>
            <Component />
        </Layout>
    )
}

export default function Navigation() {

    const [userRole, setUserRole] = useState(localStorage.getItem('role') ?? null)
    const [loginKey, setLoginKey] = useState(0);

    useEffect(() => {
        setUserRole(localStorage.getItem('role'))
    }, [loginKey]);

    const handleLogin = () => {
        setLoginKey(key => key + 1);
    };

    const handleNotFound = (Component) => {
        return localStorage.getItem('token') ? <MainLayout><Component /></MainLayout> : <Component />
    }

    const handleComponent = (adminComponent = null, courtComponent = null) => {

        if (userRole === SUPER_ADMIN && adminComponent) {
            return adminComponent;
        }

        if (userRole === COURT_USER && courtComponent) {
            return courtComponent;
        }

        return NotFound
    }

    return (
        <Router>
            <Switch>
                <Route exact path={'/login'} component={() => <AuthLayout><Login onLogin={handleLogin} /></AuthLayout>} />
                <Route exact path={'/forgot-password'} component={() => <AuthLayout><ForgotPassword /></AuthLayout>} />
                <Route exact path={'/email-sent'} component={() => <AuthLayout><EmailSent /></AuthLayout>} />
                <Route exact path={'/verify-otp'} component={() => <AuthLayout><VerifyOtp /></AuthLayout>} />
                <Route exact path={'/reset-password'} component={() => <AuthLayout><ResetPassword /></AuthLayout>} />
                <Route exact path={'/terms-and-policy'} component={TermsAndPolicy} />
                <Route exact path={'/privacy-policy'} component={PrivacyPolicy} />

                <Route exact path={'/'} component={() => wrapper(MainLayout, handleComponent(AdminDashboard, CourtDashboard))} />
                <Route exact path={'/profile:id?'} component={() => wrapper(MainLayout, handleComponent(Profile,null))} />
                <Route exact path={'/update-profile/:id?'} component={() => wrapper(MainLayout, handleComponent(UpdateProfile,null))} />
                <Route exact path={'/users:id?'} component={() => wrapper(MainLayout, handleComponent(Users, null))} />
                <Route exact path={'/users/:id?'} component={() => wrapper(MainLayout, handleComponent(UserDetails, null))} />
                <Route exact path={'/users/edit/:id?'} component={() => wrapper(MainLayout, handleComponent(UserForm, null))} />
                <Route exact path={'/referred-users'} component={() => wrapper(MainLayout, handleComponent(ReferredUsers, null))} />
                {/* <Route exact path={'/payments'} component={() => wrapper(MainLayout, handleComponent(Payments, CourtUserPayments))} />
                <Route exact path={'/courts'} component={() => wrapper(MainLayout, handleComponent(Courts, null))} />
                <Route exact path={'/bookings'} component={() => wrapper(MainLayout, handleComponent(null, CourtUserBookings))} /> */}
                <Route exact path={'/events/:id'} component={() => wrapper(MainLayout, handleComponent(EventDetails, null))} />
                <Route exact path={'/events'} component={() => wrapper(MainLayout, handleComponent(Events, null))} />
                <Route exact path={'/pages'} component={() => wrapper(MainLayout, handleComponent(Pages, null))} />
                <Route exact path={'/settings'} component={() => wrapper(MainLayout, handleComponent(Settings, null))} />
                {/* <Route exact path={'/events/waitlist/:id?'} component={() => wrapper(MainLayout, handleComponent(Waitlist, null))} /> */}
                <Route exact path={'/referrals'} component={() => wrapper(MainLayout, handleComponent(Referrals, null))} />
                <Route exact path={'/questions'} component={() => wrapper(MainLayout, handleComponent(Questions, null))} />
                <Route exact path={'/questions/:id?'} component={() => wrapper(MainLayout, handleComponent(QuestionDetails, null))} />
                <Route exact path={'/liststyle-questions'} component={() => wrapper(MainLayout, handleComponent(ListstyleQuestions, null))} />
                <Route exact path={'/liststyle-questions/:id?'} component={() => wrapper(MainLayout, handleComponent(ListstyleQuestionDetails, null))} />
                <Route exact path={'/interest'} component={() => wrapper(MainLayout, handleComponent(Interest, null))} />
                <Route exact path={'/interest/:id?'} component={() => wrapper(MainLayout, handleComponent(InterestDetails, null))} />
                <Route exact path={'/ethnicities'} component={() => wrapper(MainLayout, handleComponent(Ethnicities, null))} />
                <Route exact path={'/ethnicities/:id?'} component={() => wrapper(MainLayout, handleComponent(EthnicityDetails, null))} />
                <Route exact path={'/origin-countries'} component={() => wrapper(MainLayout, handleComponent(OriginCountries, null))} />
                <Route exact path={'/origin-countries/:id?'} component={() => wrapper(MainLayout, handleComponent(OriginCountryDetails, null))} />
                <Route exact path={'/broadcast'} component={() => wrapper(MainLayout, handleComponent(BroadCast, null))} />
                <Route exact path={'/broadcast/:id?'} component={() => wrapper(MainLayout, handleComponent(BroadCastDetails, null))} />
                <Route exact path={'/contact-us'} component={() => wrapper(MainLayout, handleComponent(ContactUs, null))} />
                <Route exact path={'/user-verification'} component={() => wrapper(MainLayout, handleComponent(UserVerification, null))} />
                <Route exact path={'/transactions'} component={() => wrapper(MainLayout, handleComponent(Subscriptions, null))} />
                <Route exact path={'/transactions/:id'} component={() => wrapper(MainLayout, handleComponent(SubscriptionDetails, null))} />
                {/* <Route exact path={'/subscription-analytics'} component={() => wrapper(MainLayout, handleComponent(SubscriptionAnalytics, null))} /> */}
                <Route exact path={'/reports'} component={() => wrapper(MainLayout, handleComponent(Reports, null))} />
                <Route exact path={'/global-test-ads'} component={() => wrapper(MainLayout, handleComponent(GlobalTestAds, null))} />
                {/* <Route exact path={'/membership-plans'} component={() => wrapper(MainLayout, handleComponent(Memberships, null))} /> */}

                <Route path="*" component={() => handleNotFound(NotFound)} />
            </Switch>
        </Router>
    )
}